import React from 'react';
import { connect } from 'react-redux';
import { TWLogo } from '.';
import { jsx as _jsx } from "react/jsx-runtime";

var TWLogoContainer = function TWLogoContainer(_ref) {
  var userIsProvider = _ref.userIsProvider;
  var href = '/';

  if (userIsProvider) {
    href = '/dashboard';
  }

  return /*#__PURE__*/_jsx(TWLogo, {
    href: href
  });
};

var mapStateToProps = function mapStateToProps(state) {
  var _state$auth$users$cur;

  return {
    userIsProvider: !!((_state$auth$users$cur = state.auth.users['current']) !== null && _state$auth$users$cur !== void 0 && _state$auth$users$cur.provider)
  };
};

export default connect(mapStateToProps)(TWLogoContainer);